import script from "./displayPsbt.vue?vue&type=script&setup=true&lang=js"
export * from "./displayPsbt.vue?vue&type=script&setup=true&lang=js"

import "./displayPsbt.vue?vue&type=style&index=0&id=403bb290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403bb290"]])

export default __exports__